import { memo } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryMutualPairsList.module.scss";
import { MutualPairs } from "shared/types/sociometry";
import { HStack, VStack } from "components/landingNew/shared/ui/Stack";
import { Icon } from "components/landingNew/shared/ui/Icon";
import { ReactComponent as Arrows } from "static/img/ic-compare.svg";

interface SociometryMutualPairsListProps {
    className?: string;
    pairs: MutualPairs[];
    showTitle?: boolean;
    variant?: "light" | "dark";
    gap?: number;
}

export const SociometryMutualPairsList = memo((props: SociometryMutualPairsListProps) => {
    const { className, pairs, showTitle = true, variant = "dark", gap = 24 } = props;
    if (!pairs.length) return <p>Взаимных выборов нет</p>;

    return (
        <VStack className={classNames(cls.sociometryMutualPairsList, {}, [className])} max gap={gap}>
            {pairs.map((pair, idx) => (
                <SociometryMutualPairItems key={idx} pair={pair} showTitle={showTitle} variant={variant} />
            ))}
        </VStack>
    );
});

SociometryMutualPairsList.displayName = "SociometryMutualPairsList";

interface SociometryMutualPairItemsProps {
    className?: string;
    pair: MutualPairs;
    showTitle?: boolean;
    variant?: "light" | "dark";
}

export const SociometryMutualPairItems = memo((props: SociometryMutualPairItemsProps) => {
    const { className, pair, showTitle = true, variant = "dark" } = props;

    const isPositive = pair.type === "positive";

    return (
        <VStack className={classNames(cls.SociometryMutualPairItems, {}, [className])} max align="center" gap={8}>
            {showTitle && (
                <p className={cls.type} style={{ color: isPositive ? "#219653" : "#EB5757" }}>
                    {isPositive ? "Положительные" : "Отрицательные"}
                </p>
            )}

            {pair.pairs.map((pair, idx) => (
                <HStack
                    key={idx}
                    className={classNames(cls.pair, { [cls.light]: variant === "light" }, [className])}
                    max
                    justify="center"
                    gap={8}
                >
                    <p className={cls.pairName}>
                        {pair.pupilA.surname} {pair.pupilA.name}
                    </p>
                    <Icon
                        Svg={Arrows}
                        width={14}
                        height={9}
                        className={classNames(cls.icon, { [cls.positive]: isPositive }, [])}
                    />
                    <p className={cls.pairName}>
                        {pair.pupilB.surname} {pair.pupilB.name}
                    </p>
                </HStack>
            ))}
        </VStack>
    );
});

SociometryMutualPairItems.displayName = "SociometryMutualPairItems";
